import { render, staticRenderFns } from "./Invasives.vue?vue&type=template&id=87fa095c"
import script from "./Invasives.vue?vue&type=script&lang=js"
export * from "./Invasives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports